import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import {
  getContactUsCategories,
  getPaginatedContactUs,
} from "../../services/axios/apiManager";
import ContactUsList from "./contactUsList";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";

const ContactUs = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [categories, setCategories] = useState([]);
  const [granted, setGranted] = useState([]);
  const [contactUs, setContactUs] = useState([]);
  const [pagination, setPagination] = useState({});

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Contact_Us");
    if (perms) {
      setGranted(perms);
    }
  };

  const getData = async () => {
    const res = await getPaginatedContactUs();
    if (res?.data?.success && res?.data?.data) {
      setContactUs(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
    const categoriesResponse = await getContactUsCategories();
    if (categoriesResponse?.data?.data) {
      setCategories(categoriesResponse.data.data);
    }
  };
  useEffect(() => {
    extractPermissions();
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div data-testid="Contact-Us">
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Dashboard</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                  >
                    Contact-Us
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <ContactUsList
          contactUs={contactUs}
          setContactUs={setContactUs}
          pagination={pagination}
          setPagination={setPagination}
          categories={categories}
          setCategories={setCategories}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};

export default ContactUs;
